import React, { useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useHistory } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import Text from 'app/components/Text'
import SignUpForm from '../../signUpForm'
import EditImageBlock from '../common/EditImageBlock'
import TextFieldEditor from '../common/TextFieldEditor'
import Button from 'app/components/ButtonDefault'

import {
  promoPageV2BackgroundImageInputProps,
  promoPageV2QuoteAuthorImageInputProps,
  promoPageV2AboutPlatformImageInputProps,
  promoPageV2InfoBoxesImagesInputProps,
} from 'app/constants/imageInputs'

import './styles.scss'

const ShowOrHide = ({ hide, children }) => {
  if (hide) {
    return null
  }
  return children
}

const bc = 'promo-page-big'

const BigVariant = ({
  isPageEdit,
  title,
  titleInputValue,
  subTitle,
  subTitleInputValue,
  formTitle,
  formTitleInputValue,
  formSubTitle,
  formSubTitleInputValue,
  welcomeText,
  welcomeTextInputValue,
  quote,
  quoteInputValue,
  quoteAuthor,
  quoteAuthorInputValue,
  quoteAuthorAbout,
  quoteAuthorAboutInputValue,
  secondTitle,
  secondTitleInputValue,
  secondSubTitle,
  secondSubTitleInputValue,
  textBoxesHeader,
  textBoxesHeaderInputValue,
  firstBoxTitle,
  firstBoxSubTitle,
  firstBoxTitleInputValue,
  firstBoxSubTitleInputValue,
  secondBoxTitle,
  secondBoxTitleInputValue,
  secondBoxSubTitle,
  secondBoxSubTitleInputValue,
  thirdBoxTitle,
  thirdBoxTitleInputValue,
  thirdBoxSubTitle,
  thirdBoxSubTitleInputValue,
  fourthBoxTitle,
  fourthBoxTitleInputValue,
  fourthBoxSubTitle,
  fourthBoxSubTitleInputValue,
  mainBackground,
  proQuoteAuthorImage,
  handleSubmit,
  change,
  platformAboutImage,
  firstBoxImage,
  secondBoxImage,
  thirdBoxImage,
  fourthBoxImage,
  mainBackgroundInputValue,
  proQuoteAuthorImageInputValue,
  platformAboutImageInputValue,
  firstBoxImageInputValue,
  secondBoxImageInputValue,
  thirdBoxImageInputValue,
  fourthBoxImageInputValue,
  pristine,
  submitting,
  valid,
  logo,
  t,
}) => {
  const history = useHistory()

  const [welcomeTextInputInitial, setWelcomeTextInputInitial] = useState(welcomeText)
  const [hideWelcomeText, setHideWelcomeText] = useState(false)

  const [titleInputInitial, setTitleInputInitial] = useState(title)
  const [hideTitle, setHideTitle] = useState(false)

  const [subTitleInputInitial, setSubTitleInputInitial] = useState(subTitle)
  const [hideSubTitle, setHideSubTitle] = useState(false)

  const [formTitleInputInitial, setFormTitleInputInitial] = useState(formTitle)
  const [hideFormTitle, setHideFormTitle] = useState(false)

  const [formSubTitleInputInitial, setFormSubTitleInputInitial] = useState(formSubTitle)
  const [hideFormSubTitle, setHideFormSubTitle] = useState(false)

  const [quoteAuthorInputInitial, setQuoteAuthorInputInitial] = useState(quoteAuthor)
  const [hideQuoteAuthor, setHideQuoteAuthor] = useState(false)

  const [quoteAuthorAboutInputInitial, setQuoteAuthorAboutInputInitial] = useState(quoteAuthorAbout)
  const [hideQuoteAuthorAbout, setHideQuoteAuthorAbout] = useState(false)

  const [quoteInputInitial, setQuoteInputInitial] = useState(quote)
  const [hideQuote, setHideQuote] = useState(false)

  const [secondTitleInputInitial, setSecondTitleInputInitial] = useState(secondTitle)
  const [hideSecondTitle, setHideSecondTitle] = useState(false)

  const [secondSubTitleInputInitial, setSecondSubTitleInputInitial] = useState(secondSubTitle)
  const [hideSecondSubTitle, setHideSecondSubTitle] = useState(false)

  const [textBoxesHeaderInputInitial, setTextBoxesHeaderInputInitial] = useState(textBoxesHeader)
  const [hideTextBoxesHeader, setHideTextBoxesHeader] = useState(false)

  const [firstBoxTitleInputInitial, setFirstBoxTitleInputInitial] = useState(firstBoxTitle)
  const [hideFirstBoxTitle, setHideFirstBoxTitle] = useState(false)

  const [firstBoxSubTitleInputInitial, setFirstBoxSubTitleInputInitial] = useState(firstBoxSubTitle)
  const [hideFirstBoxSubTitle, setHideFirstBoxSubTitle] = useState(false)

  const [secondBoxTitleInputInitial, setSecondBoxTitleInputInitial] = useState(secondBoxTitle)
  const [hideSecondBoxTitle, setHideSecondBoxTitle] = useState(false)

  const [secondBoxSubTitleInputInitial, setSecondBoxSubTitleInputInitial] = useState(secondBoxSubTitle)
  const [hideSecondBoxSubTitle, setHideSecondBoxSubTitle] = useState(false)

  const [thirdBoxTitleInputInitial, setThirdBoxTitleInputInitial] = useState(thirdBoxTitle)
  const [hideThirdBoxTitle, setHideThirdBoxTitle] = useState(false)

  const [thirdBoxSubTitleInputInitial, setThirdBoxSubTitleInputInitial] = useState(thirdBoxSubTitle)
  const [hideThirdBoxSubTitle, setHideThirdBoxSubTitle] = useState(false)

  const [fourthBoxTitleInputInitial, setFourthBoxTitleInputInitial] = useState(fourthBoxTitle)
  const [hideFourthBoxTitle, setHideFourthBoxTitle] = useState(false)

  const [fourthBoxSubTitleInputInitial, setFourthBoxSubTitleInputInitial] = useState(fourthBoxSubTitle)
  const [hideFourthBoxSubTitle, setHideFourthBoxSubTitle] = useState(false)

  const someTextFieldIsOpen = [
    hideTitle,
    hideSubTitle,
    hideFormTitle,
    hideFormSubTitle,
    hideWelcomeText,
    hideQuoteAuthor,
    hideQuote,
    hideQuoteAuthorAbout,
    hideSecondTitle,
    hideSecondSubTitle,
    hideTextBoxesHeader,
    hideFirstBoxTitle,
    hideFirstBoxSubTitle,
    hideSecondBoxTitle,
    hideSecondBoxSubTitle,
    hideThirdBoxTitle,
    hideThirdBoxSubTitle,
    hideFourthBoxSubTitle,
    hideFourthBoxTitle,
  ].includes(true)

  return (
    <div>
      <section className={bc} style={{ backgroundColor: isMobile ? '#1f2d37' : '' }}>
        <div
          className={`${bc}__bg-image`}
          style={{ backgroundImage: isMobile ? '' : `url(${mainBackgroundInputValue || mainBackground})` }}
        ></div>

        <section className={`${bc}__left`}>
          <div className={`${bc}__text-content`}>
            <div className={`${bc}__logo`}>
              <img src={logo} alt="" />
            </div>
            <div className={`${bc}__welcome-text-wrap`}>
              <TextFieldEditor
                isPageEdit={isPageEdit}
                className={`${bc}__welcome-text-icon`}
                editorClassName={`${bc}__editor`}
                hideElement={setHideWelcomeText}
                maxCharacters={40}
                name="welcomeText_v2"
                onCancel={() => {
                  /* revert the title value in the text-area */
                  change('welcomeText_v2', welcomeTextInputInitial)
                }}
                onConfirm={() => {
                  /* display value from redux-form text-area into title  */
                  setWelcomeTextInputInitial(welcomeTextInputValue)
                }}
              />
              <ShowOrHide hide={hideWelcomeText}>
                <Text htmlTag="p" customWrapperClass={`${bc}__greetings`}>
                  {welcomeTextInputInitial}
                </Text>
              </ShowOrHide>
            </div>

            <div className={`${bc}__heading-common-wrapper`}>
              <TextFieldEditor
                isPageEdit={isPageEdit}
                className={`${bc}__title-icon`}
                editorClassName={`${bc}__editor`}
                hideElement={setHideTitle}
                name="title_v2"
                maxCharacters={46}
                onCancel={() => {
                  change('title_v2', titleInputInitial)
                }}
                onConfirm={() => {
                  setTitleInputInitial(titleInputValue)
                }}
              />

              <ShowOrHide hide={hideTitle}>
                <Text htmlTag="h1" customWrapperClass={`${bc}__heading-common ${bc}__heading-first`}>
                  {titleInputInitial}
                </Text>
              </ShowOrHide>
            </div>

            <div className={`${bc}__description-common-wrapper`}>
              <TextFieldEditor
                isPageEdit={isPageEdit}
                className={`${bc}__description-common-icon`}
                editorClassName={`${bc}__editor`}
                hideElement={setHideSubTitle}
                name="subTitle_v2"
                maxCharacters={420}
                onCancel={() => {
                  change('subTitle_v2', subTitleInputInitial)
                }}
                onConfirm={() => {
                  setSubTitleInputInitial(subTitleInputValue)
                }}
              />
              <ShowOrHide hide={hideSubTitle}>
                <Text htmlTag="p" customWrapperClass={`${bc}__description-common ${bc}__description-first`}>
                  {subTitleInputInitial}
                </Text>
              </ShowOrHide>
            </div>
          </div>
        </section>

        <section className={`${bc}__right`}>
          <div className={`${bc}__img-wrapper`}>
            <EditImageBlock
              imageInputProps={promoPageV2BackgroundImageInputProps}
              minImageHeight={600}
              minImageWidth={600}
              isPageEdit={isPageEdit}
              className={`${bc}__image-upload`}
              fieldWrapperClass={`${bc}__image-upload-editor`}
              name="mainBackground_v2"
            />
            <img src={mainBackgroundInputValue || mainBackground} alt="" />
          </div>
        </section>
      </section>

      <section className={`${bc}__second`}>
        <div className={`${bc}__left`}>
          <div>
            {isPageEdit && (
              <div className={`${bc}__form-fake-headers`}>
                <div className={`${bc}__form-title-wrapper`}>
                  <TextFieldEditor
                    isPageEdit={isPageEdit}
                    className={`${bc}__form-title-icon`}
                    hideElement={setHideFormTitle}
                    name="formTitle_v2"
                    maxCharacters={50}
                    onCancel={() => {
                      change('formTitle_v2', formTitleInputInitial)
                    }}
                    onConfirm={() => {
                      setFormTitleInputInitial(formTitleInputValue)
                    }}
                  />

                  <ShowOrHide hide={hideFormTitle}>
                    <span className={`${bc}__title-form`}>{formTitleInputInitial}</span>
                  </ShowOrHide>
                </div>

                <div className={`${bc}__form-sub-title-wrapper`}>
                  <TextFieldEditor
                    isPageEdit={isPageEdit}
                    className={`${bc}__form-sub-title-icon`}
                    hideElement={setHideFormSubTitle}
                    name="formSubTitle_v2"
                    maxCharacters={64}
                    onCancel={() => {
                      change('formSubTitle_v2', formSubTitleInputInitial)
                    }}
                    onConfirm={() => {
                      setFormSubTitleInputInitial(formSubTitleInputValue)
                    }}
                  />

                  <ShowOrHide hide={hideFormSubTitle}>
                    <p className={`${bc}__subtitle-form`}>{formSubTitleInputInitial}</p>
                  </ShowOrHide>
                </div>
              </div>
            )}
            <SignUpForm
              className={`${bc}__form-wrapper`}
              isPageEdit={isPageEdit}
              formTitle={formTitle}
              formSubTitle={formSubTitle}
            />
          </div>
        </div>

        <div className={`${bc}__right`}>
          <div className={`${bc}__quote-content`}>
            <div>
              <TextFieldEditor
                isPageEdit={isPageEdit}
                className={`${bc}__quote-icon`}
                editorClassName={`${bc}__editor`}
                hideElement={setHideQuote}
                name="quote_v2"
                maxCharacters={205}
                onCancel={() => {
                  /* revert title value in the text-area */
                  change('quote_v2', quoteInputInitial)
                }}
                onConfirm={() => {
                  /* display value from redux-form text-area into title
                                at this time redux-from value already saved in the form, but we have to display this value 
                                right into quoteAuthor field   */
                  setQuoteInputInitial(quoteInputValue)
                }}
              />

              <ShowOrHide hide={hideQuote}>
                <Text htmlTag="p" customWrapperClass={`${bc}__quote`}>
                  {quoteInputInitial}
                </Text>
              </ShowOrHide>
            </div>

            <div className={`${bc}__quote-author`}>
              <div className={`${bc}__auote-author-avatar`}>
                <EditImageBlock
                  isPageEdit={isPageEdit}
                  className={`${bc}__quote-author-image-upload`}
                  fieldWrapperClass={`${bc}__quoute-author-image-editor`}
                  name="proQuoteAuthorImage_v2"
                  imageInputProps={promoPageV2QuoteAuthorImageInputProps}
                  minImageHeight={80}
                  minImageWidth={80}
                />
                <img src={proQuoteAuthorImageInputValue || proQuoteAuthorImage} alt="quote author avatar" />
              </div>
              <div>
                <div className={`${bc}__quote-author-wrap`}>
                  <TextFieldEditor
                    isPageEdit={isPageEdit}
                    className={`${bc}__quote-author-icon`}
                    editorClassName={`${bc}__editor`}
                    hideElement={setHideQuoteAuthor}
                    name="quoteAuthor_v2"
                    maxCharacters={80}
                    onCancel={() => {
                      change('quoteAuthor_v2', quoteAuthorInputInitial)
                    }}
                    onConfirm={() => {
                      setQuoteAuthorInputInitial(quoteAuthorInputValue)
                    }}
                  />

                  <ShowOrHide hide={hideQuoteAuthor}>
                    <p className={`${bc}__quote-author-info`}>{quoteAuthorInputInitial}</p>
                  </ShowOrHide>
                </div>

                <div className={`${bc}__quote-author-wrap`}>
                  <TextFieldEditor
                    isPageEdit={isPageEdit}
                    className={`${bc}__quote-author-about-icon`}
                    editorClassName={`${bc}__editor`}
                    hideElement={setHideQuoteAuthorAbout}
                    name="quoteAuthorAbout_v2"
                    maxCharacters={60}
                    onCancel={() => {
                      change('quoteAuthorAbout_v2', quoteAuthorAboutInputInitial)
                    }}
                    onConfirm={() => {
                      setQuoteAuthorAboutInputInitial(quoteAuthorAboutInputValue)
                    }}
                  />

                  <ShowOrHide hide={hideQuoteAuthorAbout}>
                    <p className={`${bc}__quote-author-info`}>{quoteAuthorAboutInputInitial} </p>
                  </ShowOrHide>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={`${bc}__third`}>
        <div className={`${bc}__left`}>
          <div className={`${bc}__third-text-content`}>
            <div className={`${bc}__second-title-wrap`}>
              <TextFieldEditor
                isPageEdit={isPageEdit}
                className={`${bc}__second-title-icon`}
                editorClassName={`${bc}__editor`}
                hideElement={setHideSecondTitle}
                name="secondTitle_v2"
                maxCharacters={56}
                onCancel={() => {
                  change('secondTitle_v2', secondTitleInputInitial)
                }}
                onConfirm={() => {
                  setSecondTitleInputInitial(secondTitleInputValue)
                }}
              />

              <ShowOrHide hide={hideSecondTitle}>
                <Text htmlTag="h1" customWrapperClass={`${bc}__heading-common ${bc}__heading-third `}>
                  {secondTitleInputInitial}
                </Text>
              </ShowOrHide>
            </div>

            <div className={`${bc}__second-title-wrap`}>
              <TextFieldEditor
                isPageEdit={isPageEdit}
                maxCharacters={450}
                className={`${bc}__second-title-icon`}
                editorClassName={`${bc}__editor`}
                hideElement={setHideSecondSubTitle}
                name="secondSubTitle_v2"
                onCancel={() => {
                  change('secondSubTitle_v2', secondSubTitleInputInitial)
                }}
                onConfirm={() => {
                  setSecondSubTitleInputInitial(secondSubTitleInputValue)
                }}
              />

              <ShowOrHide hide={hideSecondSubTitle}>
                <Text htmlTag="p" customWrapperClass={`${bc}__description-common ${bc}__description-third`}>
                  {secondSubTitleInputInitial}
                </Text>
              </ShowOrHide>
            </div>
          </div>
        </div>

        <div className={`${bc}__right`}>
          <div className={`${bc}__secondary-image-wrapper`}>
            <EditImageBlock
              isPageEdit={isPageEdit}
              className={`${bc}__secondary-image-upload`}
              fieldWrapperClass={`${bc}__secondary-image-upload-editor`}
              name="platformAboutImage_v2"
              imageInputProps={promoPageV2AboutPlatformImageInputProps}
              minImageHeight={490}
              minImageWidth={630}
            />
            <img className={`${bc}__secondary-image`} src={platformAboutImageInputValue || platformAboutImage} alt="" />
          </div>
        </div>
      </section>

      <section className={`${bc}__fourth`}>
        <div className={`${bc}__items-header-wrap`}>
          <TextFieldEditor
            isPageEdit={isPageEdit}
            className={`${bc}__items-header-icon`}
            editorClassName={`${bc}__editor`}
            hideElement={setHideTextBoxesHeader}
            name="textBoxesHeader_v2"
            maxCharacters={56}
            onCancel={() => {
              change('textBoxesHeader_v2', textBoxesHeaderInputInitial)
            }}
            onConfirm={() => {
              setTextBoxesHeaderInputInitial(textBoxesHeaderInputValue)
            }}
          />

          <ShowOrHide hide={hideTextBoxesHeader}>
            <Text htmlTag="h2" customWrapperClass={`${bc}__items-header`}>
              {textBoxesHeaderInputInitial}
            </Text>
          </ShowOrHide>
        </div>

        <div className={`${bc}__items`}>
          <div className={`${bc}__items-pairs`}>
            <div className={`${bc}__item`}>
              <div className={`${bc}__item-image-box`}>
                <EditImageBlock
                  isPageEdit={isPageEdit}
                  className={`${bc}__image-box-upload`}
                  fieldWrapperClass={`${bc}__image-box-editor`}
                  name="firstBoxImage_v2"
                  imageInputProps={promoPageV2InfoBoxesImagesInputProps}
                  minImageHeight={125}
                  minImageWidth={125}
                />
                <img src={firstBoxImageInputValue || firstBoxImage} alt="" />
              </div>
              <div className={`${bc}__box-title-wrap`}>
                <TextFieldEditor
                  isPageEdit={isPageEdit}
                  className={`${bc}__items-title-icon`}
                  editorClassName={`${bc}__editor`}
                  hideElement={setHideFirstBoxTitle}
                  name="firstBoxTitle_v2"
                  maxCharacters={30}
                  onCancel={() => {
                    change('firstBoxTitle_v2', firstBoxTitleInputInitial)
                  }}
                  onConfirm={() => {
                    setFirstBoxTitleInputInitial(firstBoxTitleInputValue)
                  }}
                />

                <ShowOrHide hide={hideFirstBoxTitle}>
                  <Text htmlTag="h3" customWrapperClass={`${bc}__item-header`}>
                    {firstBoxTitleInputInitial}
                  </Text>
                </ShowOrHide>
              </div>

              <div className={`${bc}__box-title-wrap`}>
                <TextFieldEditor
                  isPageEdit={isPageEdit}
                  className={`${bc}__items-sub-title-icon`}
                  editorClassName={`${bc}__editor`}
                  hideElement={setHideFirstBoxSubTitle}
                  name="firstBoxSubTitle_v2"
                  maxCharacters={80}
                  onCancel={() => {
                    change('firstBoxSubTitle_v2', firstBoxSubTitleInputInitial)
                  }}
                  onConfirm={() => {
                    setFirstBoxSubTitleInputInitial(firstBoxSubTitleInputValue)
                  }}
                />

                <ShowOrHide hide={hideFirstBoxSubTitle}>
                  <Text htmlTag="p" customWrapperClass={`${bc}__item-description`}>
                    {firstBoxSubTitleInputInitial}
                  </Text>
                </ShowOrHide>
              </div>
            </div>

            <div className={`${bc}__item`}>
              <div className={`${bc}__item-image-box`}>
                <EditImageBlock
                  isPageEdit={isPageEdit}
                  className={`${bc}__image-box-upload`}
                  fieldWrapperClass={`${bc}__image-box-editor`}
                  name="secondBoxImage_v2"
                  imageInputProps={promoPageV2InfoBoxesImagesInputProps}
                  minImageHeight={125}
                  minImageWidth={125}
                />
                <img src={secondBoxImageInputValue || secondBoxImage} alt="" />
              </div>

              <div className={`${bc}__box-title-wrap`}>
                <TextFieldEditor
                  isPageEdit={isPageEdit}
                  className={`${bc}__items-title-icon`}
                  editorClassName={`${bc}__editor`}
                  hideElement={setHideSecondBoxTitle}
                  name="secondBoxTitle_v2"
                  maxCharacters={30}
                  onCancel={() => {
                    /* revert the title value in the text-area */
                    change('secondBoxTitle_v2', secondBoxTitleInputInitial)
                  }}
                  onConfirm={() => {
                    /* display value from redux-form text-area into title  */
                    setSecondBoxTitleInputInitial(secondBoxTitleInputValue)
                  }}
                />

                <ShowOrHide hide={hideSecondBoxTitle}>
                  <Text htmlTag="h3" customWrapperClass={`${bc}__item-header`}>
                    {secondBoxTitleInputInitial}
                  </Text>
                </ShowOrHide>
              </div>

              <div className={`${bc}__box-title-wrap`}>
                <TextFieldEditor
                  isPageEdit={isPageEdit}
                  className={`${bc}__items-sub-title-icon`}
                  editorClassName={`${bc}__editor`}
                  hideElement={setHideSecondBoxSubTitle}
                  name="secondBoxSubTitle_v2"
                  maxCharacters={80}
                  onCancel={() => {
                    change('secondBoxSubTitle_v2', secondBoxSubTitleInputInitial)
                  }}
                  onConfirm={() => {
                    setSecondBoxSubTitleInputInitial(secondBoxSubTitleInputValue)
                  }}
                />

                <ShowOrHide hide={hideSecondBoxSubTitle}>
                  <Text htmlTag="p" customWrapperClass={`${bc}__item-description`}>
                    {secondBoxSubTitleInputInitial}
                  </Text>
                </ShowOrHide>
              </div>
            </div>
          </div>

          <div className={`${bc}__items-pairs`}>
            <div className={`${bc}__item`}>
              <div className={`${bc}__item-image-box`}>
                <EditImageBlock
                  isPageEdit={isPageEdit}
                  className={`${bc}__image-box-upload`}
                  fieldWrapperClass={`${bc}__image-box-editor`}
                  name="thirdBoxImage_v2"
                  imageInputProps={promoPageV2InfoBoxesImagesInputProps}
                  minImageHeight={125}
                  minImageWidth={125}
                />
                <img src={thirdBoxImageInputValue || thirdBoxImage} alt="" />
              </div>

              <div className={`${bc}__box-title-wrap`}>
                <TextFieldEditor
                  isPageEdit={isPageEdit}
                  className={`${bc}__items-title-icon`}
                  editorClassName={`${bc}__editor`}
                  hideElement={setHideThirdBoxTitle}
                  name="thirdBoxTitle_v2"
                  maxCharacters={30}
                  onCancel={() => {
                    change('thirdBoxTitle_v2', thirdBoxTitleInputInitial)
                  }}
                  onConfirm={() => {
                    setThirdBoxTitleInputInitial(thirdBoxTitleInputValue)
                  }}
                />

                <ShowOrHide hide={hideThirdBoxTitle}>
                  <Text htmlTag="h3" customWrapperClass={`${bc}__item-header`}>
                    {thirdBoxTitleInputInitial}
                  </Text>
                </ShowOrHide>
              </div>

              <div className={`${bc}__box-title-wrap`}>
                <TextFieldEditor
                  isPageEdit={isPageEdit}
                  className={`${bc}__items-sub-title-icon`}
                  editorClassName={`${bc}__editor`}
                  hideElement={setHideThirdBoxSubTitle}
                  name="thirdBoxSubTitle_v2"
                  maxCharacters={80}
                  onCancel={() => {
                    change('thirdBoxSubTitle_v2', thirdBoxSubTitleInputInitial)
                  }}
                  onConfirm={() => {
                    setThirdBoxSubTitleInputInitial(thirdBoxSubTitleInputValue)
                  }}
                />
                <ShowOrHide hide={hideThirdBoxSubTitle}>
                  <Text htmlTag="p" customWrapperClass={`${bc}__item-description`}>
                    {thirdBoxSubTitleInputInitial}
                  </Text>
                </ShowOrHide>
              </div>
            </div>

            <div className={`${bc}__item`}>
              <div className={`${bc}__item-image-box`}>
                <EditImageBlock
                  isPageEdit={isPageEdit}
                  className={`${bc}__image-box-upload`}
                  fieldWrapperClass={`${bc}__image-box-editor`}
                  name="fourthBoxImage_v2"
                  imageInputProps={promoPageV2InfoBoxesImagesInputProps}
                  minImageHeight={125}
                  minImageWidth={125}
                />
                <img src={fourthBoxImageInputValue || fourthBoxImage} alt="" />
              </div>
              <div className={`${bc}__box-title-wrap`}>
                <TextFieldEditor
                  isPageEdit={isPageEdit}
                  className={`${bc}__items-title-icon`}
                  editorClassName={`${bc}__editor`}
                  hideElement={setHideFourthBoxTitle}
                  name="fourthBoxTitle_v2"
                  maxCharacters={30}
                  onCancel={() => {
                    change('fourthBoxTitle_v2', fourthBoxSubTitleInputInitial)
                  }}
                  onConfirm={() => {
                    setFourthBoxTitleInputInitial(fourthBoxTitleInputValue)
                  }}
                />

                <ShowOrHide hide={hideFourthBoxTitle}>
                  <Text htmlTag="h3" customWrapperClass={`${bc}__item-header`}>
                    {isPageEdit ? fourthBoxTitleInputInitial : fourthBoxTitle}
                  </Text>
                </ShowOrHide>
              </div>

              <div className={`${bc}__box-title-wrap`}>
                <TextFieldEditor
                  isPageEdit={isPageEdit}
                  className={`${bc}__items-sub-title-icon`}
                  editorClassName={`${bc}__editor`}
                  hideElement={setHideFourthBoxSubTitle}
                  name="fourthBoxSubTitle_v2"
                  maxCharacters={80}
                  onCancel={() => {
                    change('fourthBoxSubTitle_v2', fourthBoxSubTitleInputInitial)
                  }}
                  onConfirm={() => {
                    setFourthBoxSubTitleInputInitial(fourthBoxSubTitleInputValue)
                  }}
                />

                <ShowOrHide hide={hideFourthBoxSubTitle}>
                  <Text htmlTag="p" customWrapperClass={`${bc}__item-description`}>
                    {isPageEdit ? fourthBoxSubTitleInputInitial : fourthBoxSubTitle}
                  </Text>
                </ShowOrHide>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className={`${bc}__footer`}>
        <div className={`${bc}__footer-content`}>
          <a className={`${bc}__footer-link`} href="www.prohabits. com">
            www.prohabits. com
          </a>
          <div className={`${bc}__footer-linkedin`}>
            <a href="https://www.linkedin.com/company/prohabitsplatform">
              <img src="https://assets.prohabits.com/public/linkedin-logo.png" alt="" />
            </a>
          </div>
          <Text htmlTag="span" customWrapperClass={`${bc}__footer-copyright`}>
            {' '}
            © 2020 ProHabits, Inc.
          </Text>
        </div>
      </footer>

      <ShowOrHide hide={!isPageEdit}>
        <div className={`${bc}__buttons-block`}>
          <Button onClick={history.goBack}> {t('Go back')} </Button>

          <Button onClick={handleSubmit} disabled={pristine || submitting || !valid || someTextFieldIsOpen}>
            {t('Save changes')}
          </Button>
        </div>
      </ShowOrHide>
    </div>
  )
}

export default withTranslation('admin')(BigVariant)
